export default __webpack_public_path__ + "static/media/sc.cf087314.jpg";